'use client';

import { useState } from 'react';
import { CalculatorProps } from '@/types';
import styles from './rangeCalculator.module.scss';
import { formatNumber, useCalculatePayment } from './utils';
import { CalculatorValues, Range } from './index';

interface RangeCalculatorProps {
  data: CalculatorProps;
  isVisible: boolean;
}

export const RangeCalculator = ({ data, isVisible }: RangeCalculatorProps) => {
  const [loanValue, setLoanValue] = useState<number>(
    data.defaultValue as number
  );
  const payment = useCalculatePayment({
    interestValue: data.rateValue as number,
    loanValue,
    timeLineValue: data.timeLineValue as number,
  });

  return (
    <>
      <div className={`${styles.range_wrapper} ${styles[data.variation]}`}>
        <div className={styles.range_heading}>
          <p className={styles.heading}>{data.rangeHeading}</p>
          <div className={`${styles.loan_value} ${styles[data.variation]}`}>
            ${formatNumber(loanValue)}
          </div>
        </div>
        <Range
          min={data.min}
          max={data.max}
          step={data.step}
          value={loanValue}
          onChange={setLoanValue}
          isVisible={data.variation === 'medium' ? isVisible : null}
        />
      </div>
      <div
        className={`${styles.values_wrapper} ${styles[data.variation]} ${isVisible ? styles.isVisible : ''}`}
      >
        <CalculatorValues data={data} payment={payment} />
      </div>
    </>
  );
};
